export default __webpack_public_path__ + "static/media/Paradela.359c4528.jpg";